import { useContext, useEffect, useState, useCallback } from "react";
import Header from "../../components/UI/Client/Header/header";
import classes from "./dashboard.module.css";
import { UserContext } from "../../context";
import { Outlet } from "react-router-dom";
import ClientSidebar from "../../components/UI/Client/Sidebar/sidebar";
import { companyProfile } from "../../services/clientCalls";
import { DocumentHeader } from "../../components/Seo";

const DashboardLayout = () => {
  const { setCount } = useContext(UserContext);

  // ── Profile data ──────────────────────────────────────────────────────────
  const [data, setData] = useState(null);

  useEffect(() => {
    setCount(10);
    window.scrollTo(0, 0);
  }, []);

  const refreshProfile = useCallback(async () => {
    try {
      const res = await companyProfile();
      if (res.data.data.client) setData(res.data.data.client);
    } catch (_) {}
  }, []);

  useEffect(() => {
    refreshProfile();
  }, [refreshProfile]);

  useEffect(() => {
    const onProfileUpdated = () => refreshProfile();
    window.addEventListener("client-profile-updated", onProfileUpdated);
    return () => window.removeEventListener("client-profile-updated", onProfileUpdated);
  }, [refreshProfile]);

  // ── Sidebar state ─────────────────────────────────────────────────────────
  const [sidebarCollapsed,   setSidebarCollapsed]   = useState(false);
  const [sidebarMobileOpen,  setSidebarMobileOpen]  = useState(false);

  // ── Mobile search state ───────────────────────────────────────────────────
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);

  // Start mobile with sidebar closed
  useEffect(() => {
    if (window.innerWidth <= 768) setSidebarMobileOpen(false);
  }, []);

  // Close mobile sidebar on resize to desktop
  useEffect(() => {
    const handler = () => {
      if (window.innerWidth > 768) setSidebarMobileOpen(false);
    };
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  const handleSidebarToggle = () => {
    if (window.innerWidth <= 768) {
      setSidebarMobileOpen((p) => !p);
    } else {
      setSidebarCollapsed((p) => !p);
    }
  };

  const mainClass = [
    classes.mainContent,
    sidebarCollapsed ? classes.mainCollapsed : "",
  ].filter(Boolean).join(" ");

  return (
    <div className="main-dashboard-page">
      <DocumentHeader title="Hiring dashboard" />

      <Header
        sidebarCollapsed={sidebarCollapsed}
        sidebarMobileOpen={sidebarMobileOpen}
        mobileSearchOpen={mobileSearchOpen}
        onSidebarToggle={handleSidebarToggle}
        onMobileSearchToggle={() => setMobileSearchOpen((p) => !p)}
        onMobileSearchClose={() => setMobileSearchOpen(false)}
        data={data}
      />

      <ClientSidebar
        collapsed={sidebarCollapsed}
        mobileOpen={sidebarMobileOpen}
        onOverlayClick={() => setSidebarMobileOpen(false)}
        data={data}
      />

      {/* Main shifts right by the sidebar width */}
      <main className={mainClass}>
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;
